var React = require('react');

function Invoice (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.3362 10.9609H10.2664V13.9038H22.3362V10.9609Z","fill":"#8C95A3","key":0}),React.createElement("path",{"d":"M22.3362 16.1055H10.2664V19.0483H22.3362V16.1055Z","fill":"#8C95A3","key":1}),React.createElement("path",{"d":"M10.2612 10.9593V13.8969H22.331V16.1067H10.2612V19.0443H22.331V25.2389L4.52734 25.3122V8.82813L8.42843 4.71759L22.331 4.69141V10.9593H10.2612Z","fill":"#C7CED4","key":2}),React.createElement("path",{"d":"M25.4729 10.9609H22.3311V13.8985H25.4729V10.9609Z","fill":"#4F555F","key":3}),React.createElement("path",{"d":"M25.4729 16.1055H22.3311V19.0431H25.4729V16.1055Z","fill":"#4F555F","key":4})]);
}

Invoice.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Invoice;

Invoice.default = Invoice;
